import { setTitle } from '../../utils/browser';

export function createTitleGuard(router) {
  router.afterEach((to) => {
    setTitle(to.meta.title);
    return true;
  });
}
